import React from 'react';
import { TrendingDownIcon, DollarSignIcon, AlertCircleIcon, BookOpenIcon, BarChartIcon, CalendarIcon, CalculatorIcon, ArrowUpIcon, PiggyBankIcon, CreditCardIcon, LockIcon, BrainIcon } from 'lucide-react';
interface CustomIconProps {
  name: string;
  size?: number;
  className?: string;
}
export const CustomIcon = ({
  name,
  size = 24,
  className = ''
}: CustomIconProps) => {
  const iconProps = {
    size,
    className: `${className}`
  };
  switch (name) {
    case 'trending-down':
      return <TrendingDownIcon {...iconProps} data-id="element-132" />;
    case 'dollar':
      return <DollarSignIcon {...iconProps} data-id="element-133" />;
    case 'alert':
      return <AlertCircleIcon {...iconProps} data-id="element-134" />;
    case 'book':
      return <BookOpenIcon {...iconProps} data-id="element-135" />;
    case 'chart':
      return <BarChartIcon {...iconProps} data-id="element-136" />;
    case 'calendar':
      return <CalendarIcon {...iconProps} data-id="element-137" />;
    case 'calculator':
      return <CalculatorIcon {...iconProps} data-id="element-138" />;
    case 'arrow-up':
      return <ArrowUpIcon {...iconProps} data-id="element-139" />;
    case 'piggy-bank':
      return <PiggyBankIcon {...iconProps} data-id="element-140" />;
    case 'credit-card':
      return <CreditCardIcon {...iconProps} data-id="element-141" />;
    case 'lock':
      return <LockIcon {...iconProps} data-id="element-142" />;
    case 'brain':
      return <BrainIcon {...iconProps} data-id="element-143" />;
    default:
      return <AlertCircleIcon {...iconProps} data-id="element-144" />;
  }
};